import { MDBAlert, MDBBtn, MDBModalFooter, MDBSpinner } from 'mdb-react-ui-kit';
import React, { forwardRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { deleteGroupUser } from '../../../apiclients/streamsapi_bridge';

const DeleteUserGroup = forwardRef((props, ref) => {
    const [internalError, setInternalError] = useState(false);
    const { t, i18n } = useTranslation();
    //const [isloading, setIsloading] = useState(false);
    const navigate = useNavigate();

    async function removeThisGroup(e) {
        try {
            setInternalError(false);
            props.setIsloading(true);
            let deleteGrpReponse = await deleteGroupUser(JSON.parse(sessionStorage.getItem("admin_session")).siteid, props.groupId);
            setTimeout(() => { props.setIsloading(false) }, 1000);
            let delInfo = await deleteGrpReponse.json();
            if (deleteGrpReponse.status == 200) {
                if (delInfo.status == 'success') {
                    sessionStorage.setItem("ugroup_updated", true);
                    props.setSuccessMessage(delInfo.message);
                    navigate("/userlanding", {
                        state: { tab: "mgroups" },
                    });
                    window.location.reload();
                    // window.location.href = "/huntgroup";
                    props.onClose();
                } else {
                    // localStorage.setItem("f_message", delInfo.message);
                }
            } else if (delInfo.status == 400) {
                // localStorage.setItem("f_message",delInfo?.message?.errors?.[0]?.message ?? delInfo?.message);
            } else if (delInfo.status == 500) {
                setInternalError(true);
            }

        } catch (e) {
            console.log(`Unable to process Request :Internal server Error:!`);
            setInternalError(true);
        }
    }
    return (
        <>
            {internalError && (<MDBAlert
                open
                className="alert-center"
                color="danger"
                autohide
                position="bottom-right"
                delay={5000}
            >Internal Server Error</MDBAlert>)}
            <div>
                <span className="phrecording">{t("RemoveUserGrouptxt")}</span>
            </div>

            <div style={{ display: "none" }}>
                <button ref = {ref} onClick = {(e) => removeThisGroup(e)}>
                    {t("remove")}</button>
            </div>

            {/* <MDBModalFooter>
                <MDBBtn color="secondary" onClick={props.onClose}>
                    {t("cancel")}
                </MDBBtn>
                <MDBBtn onClick={(e) => removeThisGroup(e)}>{t("remove")}</MDBBtn>
            </MDBModalFooter> */}
            {/* {isloading && (
                <>
                    <div className="loadingclass">
                        <MDBBtn disabled>
                            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                            Loading...
                        </MDBBtn>
                    </div>
                </>
            )} */}
        </>
    );
});

export default DeleteUserGroup
